<template>
    <div class="ma-4">
        <ClientNav class="hideOnPrint"/>
        <v-row dense class="hideOnPrint">
            <v-col cols="12">
                <v-card>
                    <v-card-title style="background-color: #2b3990">
                        <span class="headline white--text">{{ titleForm }}</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12" sm="12" md="3">
                                    <DatePicker
                                        v-model="newStartDate"
                                        label="Start Date"
                                        :default-date="newStartDate"
                                    ></DatePicker>
                                </v-col>
                                <v-col cols="6" sm="12" md="3">
                                    <DatePicker
                                        v-model="newEndDate"
                                        label="End Date"
                                        :default-date="newEndDate"
                                    ></DatePicker>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-select
                                        :items="months"
                                        v-model="newMonth"
                                        label='Select a Month'
                                        hint="What month is this monthly summary for?"
                                    ></v-select>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-flex xs12 md3 class="mt-5 mb-5 pl-5">
                                        <v-btn x-small @click="getAllWeeklyReportWithinDateRange()">Search</v-btn>
                                    </v-flex>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">

                                    <v-text-field
                                        :value="newPlanDate"
                                        label="Date"
                                        prepend-icon="events"
                                        v-model="newCurrentDate"
                                        readonly
                                        hint="Current Date"
                                    ></v-text-field>

                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <DatePicker
                                        v-model="newPlanDate"
                                        label="Plan Date"
                                        :default-date="newPlanDate"
                                    ></DatePicker>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <v-select
                                        label="Service Code"
                                        :items="codes"
                                        item-text="ServiceCode"
                                        item-value="ServiceCode"
                                        v-model="newCode"
                                    ></v-select>
                                </v-col>
                                <v-col cols="12" sm="12" v-if="createMonthlySummary">
                                    <v-select
                                        return-object
                                        label="Goal"
                                        v-model="goal"
                                        :items="goals"
                                        item-value="Goal"
                                        item-text="Goal"
                                        @change="updateGoal(goal)"

                                    ></v-select>
                                </v-col>

                                <v-col cols="12" sm="12" v-if="updateSummary">
                                    <v-textarea
                                        label="Goal"
                                        v-model="newGoal"
                                        outlined
                                    ></v-textarea>
                                </v-col>

                                <v-col cols="12" sm="12">
                                    <v-textarea
                                        label="Purpose"
                                        outlined
                                        v-model="newPurpose"
                                    ></v-textarea>
                                </v-col>
                                <v-col cols="12" sm="12">
                                    <v-textarea
                                        label="Details of the Support"
                                        outlined
                                        v-model="newDetails"
                                    ></v-textarea>
                                </v-col>
                                <v-col
                                    cols="12"
                                    sm="12"
                                >
                                    <v-textarea
                                        v-model="summaryTitle"
                                        label="Summary"
                                        outlined
                                    ></v-textarea>
                                </v-col>
                                <v-col cols="12" sm="12">
                                    <template>
                                        <v-data-table v-model="newSummary"
                                                      :headers="addMonthlySummaryHeaders" :items="allWeeklySummaries"
                                                      hide-default-footer
                                                      disable-pagination
                                                      class="elevation-1"

                                        ></v-data-table>
                                    </template>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <v-checkbox
                                        v-model="signedManager"
                                        label="Manager Signature"
                                        outlined
                                        @click="addManagerSig()"
                                    ></v-checkbox>
                                    <v-text-field label="Signed By" v-model="newManagerSignature"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6"></v-col>
                                <v-col cols="6" sm="6" md="6">
                                    <v-checkbox
                                        v-model="signedSupervisor"
                                        label="Supervisor Signature"
                                        outlined
                                        @click="addSupervisorSig()"
                                    ></v-checkbox>
                                    <v-text-field label="Signed By" v-model="newSupervisorSignature"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6"></v-col>
                                <v-col cols="6" sm="6" md="6">
                                    <v-checkbox
                                        v-model="signedClient"
                                        label="Client Services Signature"
                                        outlined
                                        @click="addClientSig()"
                                    ></v-checkbox>
                                    <v-text-field label="Signed By" v-model="newClientServSig"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6"></v-col>
                                <v-col cols="6" sm="6" md="6">
                                    <DatePicker
                                        v-model="newSubmitted"
                                        label="Submitted"
                                        :default-date="newSubmitted"
                                    ></DatePicker>
                                </v-col>
                                <v-col>
                                    <v-select
                                        label="Providers"
                                        :items="providers"
                                        item-text="Name"
                                        item-value="Name"
                                        v-model="newProviders"
                                    >
                                    </v-select>
                                </v-col>
                                <v-col>
                                    <v-select
                                        multiple
                                        label="Email Contact"
                                        v-model="newGuardian"
                                    >
                                    </v-select>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="white--text" color="#259647" @click="addMonthlySummary()"
                               v-if="createMonthlySummary">
                            Save
                        </v-btn
                        >
                        <v-btn
                            fab
                            small
                            @click="printItem()"
                            class="mr-8 mb-2 white--text"
                            color="#2b6993"
                            elevation="4"
                            v-if="updateSummary"
                        >
                            <v-icon>print</v-icon>
                        </v-btn>
                        <v-btn color="blue darken-1" text @click="updateMonthlySummary()" v-if="updateSummary">Update
                        </v-btn
                        >
                        <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <Foot class="hideOnPrint"/>

        <div id="printItem">
            <h2 class="text-center ma-3">Monthly Summary - {{ newMonth }}</h2>
            <v-row>
                <v-col cols="12" sm="4">

                    PLAN DATE: {{ newPlanDate }}

                </v-col>
                <v-col cols="12" sm="4">

                </v-col>
                <v-col cols="12" sm="4">

                    SERVICE CODE: {{ newCode }}
                </v-col>
                <v-col cols="12" sm="12">

                    GOAL: <br>
                    {{ newGoal }}
                </v-col>

                <v-col cols="12" sm="12">

                    PURPOSE <br>
                    {{ newPurpose }}
                </v-col>
                <v-col cols="12" sm="12">

                    DETAILS OF THE SUPPORT <br>
                    {{ newDetails }}
                </v-col>
                <v-col
                    cols="12"
                    sm="12"
                >

                    SUMMARY: <br>
                    {{ summaryTitle }}
                </v-col>
                <v-col cols="12" sm="12">

                    <template>
                        <v-data-table v-model="newSummary"
                                      :headers="addMonthlySummaryHeaders" :items="allWeeklySummaries"
                                      hide-default-footer
                                      disable-pagination
                                      class="elevation-1"

                        ></v-data-table>
                    </template>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                    <v-checkbox
                        v-model="signedManager"
                        label="Manager Signature"
                        outlined
                        @click="addManagerSig()"
                    ></v-checkbox>
                    <v-text-field label="Signed By" v-model="newManagerSignature"></v-text-field>
                </v-col>
                <v-col cols="12" md="6"></v-col>
                <v-col cols="6" sm="6" md="6">
                    <v-checkbox
                        v-model="signedSupervisor"
                        label="Supervisor Signature"
                        outlined
                        @click="addSupervisorSig()"
                    ></v-checkbox>
                    <v-text-field label="Signed By" v-model="newSupervisorSignature"></v-text-field>
                </v-col>
                <v-col cols="12" md="6"></v-col>
                <v-col cols="6" sm="6" md="6">
                    <v-checkbox
                        v-model="signedClient"
                        label="Client Services Signature"
                        outlined
                        @click="addClientSig()"
                    ></v-checkbox>
                    <v-text-field label="Signed By" v-model="newClientServSig"></v-text-field>
                </v-col>
                <v-col cols="12" md="6"></v-col>
                <v-col cols="6" sm="6" md="6">
                    <DatePicker
                        v-model="newSubmitted"
                        label="Submitted"
                        :default-date="newSubmitted"
                    ></DatePicker>
                </v-col>
                <v-col>
                    <v-select
                        label="Providers"
                        :items="providers"
                        item-text="Name"
                        item-value="Name"
                        v-model="newProviders"
                    >
                    </v-select>
                </v-col>
                <v-col>
                    <v-select
                        multiple
                        label="Email Contact"
                        v-model="newGuardian"
                    >
                    </v-select>
                </v-col>
            </v-row>

        </div>
    </div>
</template>

<script>
import axios from 'axios'
import ClientNav from '@/components/ClientNav'
import Foot from '@/components/Footer'
import DatePicker from "@/components/DateTimePickers/DatePicker.vue";
import {displayError, displaySuccess} from "@/service/notification-message.service";

const url = require("@/client_config/config").url;

export default {
    components: {
        DatePicker,
        ClientNav,
        Foot,
    },
    data: function () {
        return {
            addMonthlySummaryHeaders: [
                {
                    text: 'Report Date',
                    align: 'start',
                    value: 'ReportDate',
                },
                {text: "Summary", value: "Summary"},
                {text: "Manager Signature", value: "ManagerSignature"},
                {text: "Supervisor Signature", value: "SupervisorSignature"},
            ],
            date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            msg: false,
            signedManager: false,
            signedSupervisor: false,
            signedClient: false,
            search: "",
            text: "",
            monthlySummaries: [],
            monthlySummary: {},
            allWeeklySummaries: [],
            weeklyIdsSummaries: [],
            providers: [],
            units: [],
            codes: [],
            tempData: [],
            users: [],
            goals: [],
            staff: "",
            unitID: localStorage.getItem('unitID'),
            clientID: this.$route.params.clientID,
            monthlySummaryId: this.$route.params.id,
            userID: localStorage.getItem('userID'),
            titleForm: "New Monthly Summary",
            summaryID: "",
            newStartDate: "",
            newEndDate: "",
            newCurrentDate: new Date(),
            newPlanDate: "",
            newCode: "",
            newGoal: "",
            newPurpose: "",
            newDetails: "",
            summaryTitle: "",
            newSummary: "",
            newManagerSignature: "",
            newSupervisorSignature: "",
            newClientServSig: "",
            newSubmitted: "",
            newProviders: "",
            newGuardian: "",
            goal: '',
            tempGoals: [],
            newMonth: "",
            months: [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December",
            ],
            isLoading: true,
            createMonthlySummary: false,
            updateSummary: false,
        };
    },

    computed: {},

    watch: {},

    created() {
        this.createMonthlySummary = this.$route.query.createMonthlySummary === 'true';
        this.updateSummary = this.$route.query.updateSummary === 'true';
        this.getUsers();
        this.getServiceCodesFromCode();
        this.getListOfProviders();
        this.getStrategies()
    },

    mounted() {

        this.getMonthlySummaries();

        if (this.updateSummary) {
            console.log('update');
            this.getMonthlySummary();
        }
    },

    methods: {
        initialize() {
            this.monthlySummaries = [];
        },

        viewMonthlySummary(item) {
            this.titleForm = "Viewing Monthly Summary";
            this.dialog = true;
            this.editSummary = true;
            this.newSummary = false;
            this.newSummaryBool = false;
            this.newStartDate = item.StartDate;
            this.newEndDate = item.EndDate;
            this.newMonth = item.Month;
            this.newCurrentDate = item.CurrentDate;
            this.newPlanDate = item.PlanDate;
            this.newCode = item.Code;
            this.newGoal = item.Goal;
            this.newPurpose = item.Purpose;
            this.newDetails = item.Details;
            this.summaryTitle = item.SummaryTitle;
            this.newSummary = item.newSummary;
            this.newManagerSignature = item.ManagerSignature;
            this.signedManager = item.ManagerSig;
            this.newSupervisorSignature = item.SupervisorSignature;
            this.signedSupervisor = item.SupervisorSig;
            this.newClientServSig = item.ClientServSig;
            this.signedClient = item.ServSig;
            this.newSubmitted = item.Submitted;
            this.newProviders = item.Providers;
            this.newGuardian = item.Guardian;
            this.summaryID = item._id;
            this.getAllWeeklyReportWithinDateRange(item.newStartDate, item.newEndDate);
        },

        getStrategies() {
            axios.get(`${url}/support/${this.clientID}`).then(res => {
                this.tempGoals = res.data.supports
                this.goals = []
                for (var i = 0; i < this.tempGoals.length; i++) {
                    if (this.tempGoals[i].Active == "Active") {
                        this.goals.push(this.tempGoals[i])
                    }
                }
            })
        },

        close() {
            this.$router.go(-1);
            this.clear()
            document.getElementById('printItem').style.display = "none";
        },

        async updateMonthlySummary() {
            let req_body = {
                StartDate: this.newStartDate,
                EndDate: this.newEndDate,
                Month: this.newMonth,
                CurrentDate: this.newCurrentDate,
                PlanDate: this.newPlanDate,
                Code: this.newCode,
                Goal: this.goal.Goal,
                Purpose: this.newPurpose,
                Details: this.newDetails,
                SummaryTitle: this.summaryTitle,
                Summary: this.newSummary,
                ManagerSig: this.signedManager,
                MangerSignature: this.newManagerSignature,
                SupervisorSig: this.signedSupervisor,
                SupervisorSignature: this.newSupervisorSignature,
                ClientServSig: this.newClientServSig,
                ServSig: this.signedClient,
                Submitted: this.newSubmitted,
                Providers: this.newProviders,
                Guardian: this.newGuardian,
            };

            try {
                const response = await axios.put(`${url}/monthlySummary/${this.summaryID}`, req_body);

                if (response.status !== 200) {
                    displayError('An error occurred while updating the monthly summary.');
                }

                displaySuccess("Monthly Summary updated successfully.");
                this.getMonthlySummaries();
            } catch (error) {
                displayError("An error occurred while updating the monthly summary.");
            } finally {
                this.close();
            }
        },

        getMonthlySummaries() {
            this.isLoading = true;
            axios.get(`${url}/monthlySummary/client/${this.clientID}`).then(res => {
                this.monthlySummaries = res.data.summaries
            }).finally(() => this.isLoading = false);
        },

        getMonthlySummary() {
            this.isLoading = true;
            axios.get(`${url}/monthlySummary/${this.monthlySummaryId}`).then(res => {
                console.log({res});

                this.monthlySummary = res.data.summary
                this.viewMonthlySummary(this.monthlySummary);
            }).finally(() => this.isLoading = false);
        },

        getAllWeeklyReportWithinDateRange() {
            this.isLoading = true;
            axios.get(`${url}/weeklySummary/${this.newStartDate}/${this.newEndDate}/${this.clientID}`).then(res => {
                this.allWeeklySummaries = res.data.summaries
                for (let counterForWeeklySummaries = 0; counterForWeeklySummaries < this.allWeeklySummaries.length; counterForWeeklySummaries++) {
                    this.weeklyIdsSummaries.push(this.allWeeklySummaries[counterForWeeklySummaries]._id)
                }
            }).finally(() => this.isLoading = false);
        },

        async addMonthlySummary() {
            let req_body = {
                StartDate: this.newStartDate,
                EndDate: this.newEndDate,
                Month: this.newMonth,
                CurrentDate: this.newCurrentDate,
                PlanDate: this.newPlanDate,
                Code: this.newCode,
                Goal: this.goal.Goal,
                Purpose: this.newPurpose,
                Details: this.newDetails,
                SummaryTitle: this.summaryTitle,
                Summary: this.weeklyIdsSummaries,
                ManagerSignature: this.newManagerSignature,
                ManagerSig: this.signedManager,
                SupervisorSignature: this.newSupervisorSignature,
                SupervisorSig: this.signedSupervisor,
                ClientServSig: this.newClientServSig,
                ServSig: this.signedClient,
                Submitted: this.newSubmitted,
                Providers: this.newProviders,
                Guardian: this.newGuardian,
                ClientID: this.clientID,
            };

            try {
                const response = await axios.post(`${url}/monthlySummary`, req_body);

                if (response.status !== 200) {
                    displayError('An error occurred while adding the monthly summary.');
                }

                displaySuccess("Monthly Summary added successfully.")
                this.getMonthlySummaries();
            } catch (error) {
                displayError(error);
            } finally {
                this.close();
            }
        },

        getUsers() {
            axios.get(`${url}/users`).then(async res => {
                this.users = res.data.users;
                for (var i = 0; i < this.users.length; i++) {
                    if (this.userID == this.users[i]._id) {
                        this.staff = this.users[i].Name
                    }
                }
            });
        },

        addManagerSig() {
            if (!this.signedManager) return this.newManagerSignature = ''
            this.newManagerSignature = this.staff + " - " + new Date();
        },

        addSupervisorSig() {
            if (!this.signedSupervisor) return this.newSupervisorSignature = ''
            this.newSupervisorSignature = this.staff + " - " + new Date();
        },

        addClientSig() {
            if (!this.signedClient) return this.newClientServSig = ''
            this.newClientServSig = this.staff + " - " + new Date();
        },

        getServiceCodesFromCode() {
            axios.get(`${url}/serviceCodes/client/${this.clientID}`).then(async res => {
                this.codes = res.data.serviceCodes;
            });
        },

        getListOfProviders() {
            axios.get(`${url}/codes/providerslist`).then(async res => {
                this.providers = res.data;
            });
        },

        updateGoal(goal) {
            console.log(goal.Goal)
            this.newDetails = goal.Assist
            this.newPurpose = goal.Purpose
        },

        clear() {
            this.newStartDate = "";
            this.newEndDate = "";
            this.newMonth = "";
            this.newCurrentDate = "";
            this.newPlanDate = "";
            this.newCode = "";
            this.newGoal = "";
            this.newPurpose = "";
            this.newDetails = "";
            this.newSummary = "";
            this.summaryTitle = "";
            this.newManagerSignature = "";
            this.newSupervisorSignature = "";
            this.newClientServSig = "";
            this.newSubmitted = "";
            this.newProviders = "";
            this.newGuardian = "";
            this.allWeeklySummaries = [];
            this.signedManager = false;
            this.signedSupervisor = false;
            this.signedClient = false;
        },

        printItem() {
            document.getElementById('printItem').style.display = "block";
            window.print()
        },

    },

};
</script>
<style>
@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }

}

#printTable {
    display: none;
}

#printItem {
    display: none;
}

@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }

}

@media print {
    #printTable {
        display: block;
        border: none;
        width: 1200px;
        padding-right: 300px;
        margin-left: -200px;

    }

    #printItem {
        display: block;
        border: none;
        width: 1200px;
        padding-right: 300px;
        margin-left: -200px;


    }

    .hideOnPrint {
        display: none;
        border: none;
    }

    nav.v-navigation-drawer, header.v-toolbar, button.v-btn, div.v-card {
        display: none;
        border: none;

    }

    @page {
        margin: 0;
    }

    body {
        margin: 1.6cm;
    }


}
</style>
